<template>
  <b-card
    class="full-width"
    border-variant="info"
    header-bg-variant="primary"
    header-text-variant="white"
  >
    <div slot="header">
      <strong>{{ title }}</strong>
    </div>
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <label for="name">Field Name</label>
          <b-form-input
            :class="{ 'is-invalid': nameError }"
            type="text"
            id="name"
            :value="inputObj.attributeName"
            @change="inputMethods.changeName"
            placeholder="Enter Field Name"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group>
          <label for="type">Type</label>
          <b-form-select
            id="type"
            :value="inputObj.attributeValueType"
            @change="inputMethods.changeType"
            :options="typeOptions"
            placeholder="Attribute Type"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group>
          <label for="desc">Description</label>
          <b-form-input
            type="text"
            id="desc"
            v-model="inputObj.description"
            placeholder="Short Description"
            @change="inputMethods.changeDesc"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="flex">
      <div class="form-actions right">
        <slot name="actions"></slot>
      </div>
    </div>
    <br />
    <slot name="members"></slot>
  
  </b-card>
</template>

<style scoped>
.flex {
  display: flex;
  flex-direction: row-reverse;
}
.form-actions {
  width: max-content;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    inputObj: {
      type: Object,
      required: true
    },
    typeOptions: {
      type: Array,
      required: true
    },
    inputMethods: {
      type: Object,
      required: true
    },
    nameError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
